var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBikeRouteMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 128.14698162729658 128.14698162729658",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l128.14699 0l0 128.14699l-128.14699 0l0 -128.14699z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l128.14699 0l0 128.14699l-128.14699 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "m5.1916013 24.81929l0 0c0 -10.840074 8.787615 -19.62769 19.62769 -19.62769l78.5084 0l0 0c5.2055893 0 10.197968 2.0679111 13.878876 5.748817c3.6809006 3.6809053 5.7488174 8.673285 5.7488174 13.878872l0 78.5084c0 10.840073 -8.787621 19.627693 -19.627693 19.627693l-78.5084 0c-10.840074 0 -19.62769 -8.787621 -19.62769 -19.627693z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.1916013 24.81929l0 0c0 -10.840074 8.787615 -19.62769 19.62769 -19.62769l78.5084 0l0 0c5.2055893 0 10.197968 2.0679111 13.878876 5.748817c3.6809006 3.6809053 5.7488174 8.673285 5.7488174 13.878872l0 78.5084c0 10.840073 -8.787621 19.627693 -19.627693 19.627693l-78.5084 0c-10.840074 0 -19.62769 -8.787621 -19.62769 -19.627693z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m12.563121 96.00484l0 0c0 -10.654312 8.637027 -19.291336 19.29134 -19.291336l0 0c5.1163807 0 10.023207 2.0324707 13.641035 5.650299c3.6178284 3.6178284 5.650303 8.524658 5.650303 13.641037l0 0c0 10.654312 -8.637028 19.291344 -19.291338 19.291344l0 0c-10.654312 0 -19.29134 -8.637032 -19.29134 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m12.563121 96.00484l0 0c0 -10.654312 8.637027 -19.291336 19.29134 -19.291336l0 0c5.1163807 0 10.023207 2.0324707 13.641035 5.650299c3.6178284 3.6178284 5.650303 8.524658 5.650303 13.641037l0 0c0 10.654312 -8.637028 19.291344 -19.291338 19.291344l0 0c-10.654312 0 -19.29134 -8.637032 -19.29134 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m77.00116 96.00484l0 0c0 -10.654312 8.637032 -19.291336 19.291344 -19.291336l0 0c5.116379 0 10.023209 2.0324707 13.641029 5.650299c3.6178284 3.6178284 5.6503067 8.524658 5.6503067 13.641037l0 0c0 10.654312 -8.637024 19.291344 -19.291336 19.291344l0 0c-10.654312 0 -19.291344 -8.637032 -19.291344 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m77.00116 96.00484l0 0c0 -10.654312 8.637032 -19.291336 19.291344 -19.291336l0 0c5.116379 0 10.023209 2.0324707 13.641029 5.650299c3.6178284 3.6178284 5.6503067 8.524658 5.6503067 13.641037l0 0c0 10.654312 -8.637024 19.291344 -19.291336 19.291344l0 0c-10.654312 0 -19.291344 -8.637032 -19.291344 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m95.922745 95.03576l-10.58268 -34.204727",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m95.922745 95.03576l-10.58268 -34.204727",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m56.73296 95.2401l-10.771652 -34.393703",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m56.73296 95.2401l-10.771652 -34.393703",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m56.251312 94.859024l31.527557 -26.614174",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m56.251312 94.859024l31.527557 -26.614174",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m87.60717 67.7274l-37.82677 6.1417313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m87.60717 67.7274l-37.82677 6.1417313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m31.130577 96.05485l18.80315 -21.826767",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m31.130577 96.05485l18.80315 -21.826767",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m30.886606 95.73928l26.425196 -1.3228302",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m30.886606 95.73928l26.425196 -1.3228302",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m87.902885 60.805775l-8.566925 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m87.902885 60.805775l-8.566925 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m39.36896 60.540665l0 0c0 -0.33340454 0.27028275 -0.6036873 0.6036873 -0.6036873l9.343807 0c0.16011047 0 0.31365967 0.06360626 0.42687225 0.17681885c0.113212585 0.113212585 0.17681503 0.26676178 0.17681503 0.42686844l0 2.4146767c0 0.33340454 -0.27027893 0.6036835 -0.6036873 0.6036835l-9.343807 0c-0.33340454 0 -0.6036873 -0.27027893 -0.6036873 -0.6036835z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m39.36896 60.540665l0 0c0 -0.33340454 0.27028275 -0.6036873 0.6036873 -0.6036873l9.343807 0c0.16011047 0 0.31365967 0.06360626 0.42687225 0.17681885c0.113212585 0.113212585 0.17681503 0.26676178 0.17681503 0.42686844l0 2.4146767c0 0.33340454 -0.27027893 0.6036835 -0.6036873 0.6036835l-9.343807 0c-0.33340454 0 -0.6036873 -0.27027893 -0.6036873 -0.6036835z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m29.183727 55.23622c5.9291344 0 8.8937 -4.047245 11.858269 -8.09449c2.9645653 -4.047241 5.9291344 -8.094486 11.858265 -8.094486",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9900ff",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.183727 55.23622c5.9291344 0 8.8937 -4.047245 11.858269 -8.09449c2.9645653 -4.047241 5.9291344 -8.094486 11.858265 -8.094486",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m51.656116 38.847717c12.519688 0 18.77953 4.952759 25.039371 9.905514c6.259842 4.952755 12.519684 9.90551 25.039368 9.90551",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9900ff",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m51.656116 38.847717c12.519688 0 18.77953 4.952759 25.039371 9.905514c6.259842 4.952755 12.519684 9.90551 25.039368 9.90551",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93c47d",
    d: "m40.076065 14.980298l0 0c6.1142693 6.11427 6.1142693 16.027462 0 22.141731q-7.403862 7.403866 -11.070866 18.544586q-3.6670036 -11.14072 -11.070866 -18.544586l0 0c-6.114271 -6.1142693 -6.114271 -16.02746 0 -22.141731l0 0c6.1142693 -6.114271 16.027462 -6.114271 22.141731 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#38761d",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m40.076065 14.980298l0 0c6.1142693 6.11427 6.1142693 16.027462 0 22.141731q-7.403862 7.403866 -11.070866 18.544586q-3.6670036 -11.14072 -11.070866 -18.544586l0 0c-6.114271 -6.1142693 -6.114271 -16.02746 0 -22.141731l0 0c6.1142693 -6.114271 16.027462 -6.114271 22.141731 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9ead3",
    d: "m24.123116 26.23195l0 0c0 -2.6961937 2.1856956 -4.8818913 4.8818893 -4.8818913l0 0c1.2947578 0 2.5364857 0.51434135 3.4520187 1.4298725c0.91553116 0.91553307 1.4298706 2.157261 1.4298706 3.4520187l0 0c0 2.6961918 -2.1856956 4.8818893 -4.8818893 4.8818893l0 0c-2.6961937 0 -4.8818893 -2.1856976 -4.8818893 -4.8818893z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#38761d",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m24.123116 26.23195l0 0c0 -2.6961937 2.1856956 -4.8818913 4.8818893 -4.8818913l0 0c1.2947578 0 2.5364857 0.51434135 3.4520187 1.4298725c0.91553116 0.91553307 1.4298706 2.157261 1.4298706 3.4520187l0 0c0 2.6961918 -2.1856956 4.8818893 -4.8818893 4.8818893l0 0c-2.6961937 0 -4.8818893 -2.1856976 -4.8818893 -4.8818893z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e06666",
    d: "m113.05769 17.856937l0 0c6.114273 6.114271 6.114273 16.027462 0 22.141731q-7.403862 7.403866 -11.070869 18.54459q-3.6669998 -11.140724 -11.070862 -18.54459l0 0c-6.114273 -6.1142693 -6.114273 -16.02746 0 -22.141731l0 0c6.1142654 -6.11427 16.027458 -6.11427 22.141731 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#990000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m113.05769 17.856937l0 0c6.114273 6.114271 6.114273 16.027462 0 22.141731q-7.403862 7.403866 -11.070869 18.54459q-3.6669998 -11.140724 -11.070862 -18.54459l0 0c-6.114273 -6.1142693 -6.114273 -16.02746 0 -22.141731l0 0c6.1142654 -6.11427 16.027458 -6.11427 22.141731 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9ead3",
    d: "m97.104744 29.108591l0 0c0 -2.6961937 2.1856918 -4.8818913 4.8818893 -4.8818913l0 0c1.294754 0 2.5364838 0.51434135 3.4520187 1.4298725c0.91552734 0.91553307 1.4298706 2.157261 1.4298706 3.4520187l0 0c0 2.6961918 -2.1856995 4.8818874 -4.8818893 4.8818874l0 0c-2.6961975 0 -4.8818893 -2.1856956 -4.8818893 -4.8818874z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#990000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m97.104744 29.108591l0 0c0 -2.6961937 2.1856918 -4.8818913 4.8818893 -4.8818913l0 0c1.294754 0 2.5364838 0.51434135 3.4520187 1.4298725c0.91552734 0.91553307 1.4298706 2.157261 1.4298706 3.4520187l0 0c0 2.6961918 -2.1856995 4.8818874 -4.8818893 4.8818874l0 0c-2.6961975 0 -4.8818893 -2.1856956 -4.8818893 -4.8818874z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeRouteMapIcon);
export default __webpack_public_path__ + "static/media/bike-route-map-icon.97c3120ce1a9476e66d7d4bd6c6d1de5.svg";
export { ForwardRef as ReactComponent };